import React, { useEffect } from 'react';
import CarouselComponent from '../Components/CarouselComponent';
import ServiceCard from '../Components/ServiceCard';
import AOS from 'aos';
import { servicesData } from '../data/servicesData';
import { Helmet } from 'react-helmet-async';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocation, faLocationDot, faMap, faMarker } from '@fortawesome/free-solid-svg-icons';

function Home() {

  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: 'ease-out',
      once: true
    });

    const refreshAOS = () => AOS.refresh();
    window.addEventListener('load', refreshAOS);
    setTimeout(refreshAOS, 100);

    return () => window.removeEventListener('load', refreshAOS);
  }, []);

  const locations = ['Alabama', 'Florida', 'Georgia', 'Tennessee']

  return (
    <>
      <Helmet>
        <title>Home | OnPoint Services</title>
        <meta
          name="description"
          content="On Point Services provides reliable maintenance and renovation services in Alabama, Florida, Georgia, and Tennessee."
        />
        <meta property="og:title" content="Home | On Point Services" />
        <meta
          property="og:description"
          content="Discover top-quality handyman, plumbing, electrical, and general maintenance services across multiple locations."
        />
        <link rel="canonical" href="https://www.on-point-services.com/" />
      </Helmet>
      <div className="home">
      <div className="top-section">
<CarouselComponent />

</div>


        <div
          className="what-we-do container py-5"
          data-aos="fade-up"
          data-aos-anchor-placement="top-bottom">
          <div className="whatwedo-title text-center mb-3"><span className="display-6 text-primary me-2">🛠️</span>What We Do</div>
          <div className="lead text-center mb-4">
           At OnPoint Services we offer maintenance and renovation solutions from a single-lot.
           Our team can assuredly provide you with reliable, top-quality workmanship catered to your specifications. 
           From small repairs to major projects, we can do it all within time and budget and expertly done.
          </div>
          <div className="offer text-center" data-aos="fade-up" data-aos-anchor-placement="top-bottom">
            Here’s what we offer:
          </div>
        </div>

        <div className="services container">
          <div className="section-title text-center mb-4" data-aos="fade-up"
            data-aos-anchor-placement="top-bottom">Services</div>
          <div className="mt-4 row g-2 justify-content-center align-items-stretch">
            {servicesData.map((svc, idx) => (
              <div
                key={svc.id}
                className="col-12 col-sm-6 col-md-3 mb-4 d-flex justify-content-center"
                data-aos="fade-up"
                data-aos-delay={idx * 100}
                data-aos-anchor-placement="top-bottom"
              >
                <ServiceCard
                  id={svc.id}
                  cardTitle={svc.title}
                  cardDesc={svc.shortDesc}
                  imgUrl={svc.imgUrl}
                />
              </div>
            ))}
          </div>
        </div>

        <div className='service-area container py-5'>
          <div className='row align-items-start'>
            <div
              className='col-12 col-lg-6 mb-4 mb-lg-0'
              data-aos='fade-right'
            >
              <img
                src={"/Images/usa-map-locations.png"}
                alt="USA Location"
                className="img-fluid rounded w-100"
              />
            </div>
            <div
              className='col-12 col-lg-6'
              data-aos='fade-left'
            >
              <div className='ps-lg-5'>
                <h4 className='title mb-3'>Service Areas</h4>
                <h5 className='subtitle mb-4'>
                Our Operations cover the Great States of  <br className='d-none d-lg-block' />
                Alabama, Florida, Georgia and Tennessee
                </h5>
                <div className='row'>
                  {locations.map((loc, index) => (
                    <div key={index} className='col-6 mb-3 d-flex align-items-center'>
                      <FontAwesomeIcon icon={faLocationDot} className='me-2 location-icon' />
                      <span className='location-name'>{loc}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Home
